import { Modal, Box, Typography, FormControl, InputLabel, Select, MenuItem, TextField, RadioGroup, FormControlLabel, Radio, Button } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import totalLocationData from "../../../../../../data/locationdata";
import { postFetch } from "../../../../../../fetch/fetch";

const AddAccessModal: React.FC<any> = (props) => {
  const [location, setLocation] = useState("");
  const [dateTime, setDateTime] = useState<string>(""); // "YYYY-MM-DDTHH:mm"
  const [direction, setDirection] = useState<"inside" | "outside">("outside"); // 입실/퇴실

  // user 변경 시 기본값 세팅 (원하면 제거해도 됨)
  useEffect(() => {
    if (!props.open) return;
    setLocation("");
    setDirection("outside");

    // 현재시간 기본값
    const now = new Date();
    const pad = (n: number) => String(n).padStart(2, "0");
    const v = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;
    setDateTime(v);
  }, [props.open]);

  useEffect(() => {

    if(!props.selectedDate) return;

    const selected = new Date(props.selectedDate);
    const pad = (n: number) => String(n).padStart(2, "0");
    const v = `${selected.getFullYear()}-${pad(selected.getMonth() + 1)}-${pad(selected.getDate())}T${pad(selected.getHours())}:${pad(selected.getMinutes())}`;
    setDateTime(v);

  }, [props.selectedDate, props.open]);

  // Select 옵션 목록
  const locationOptions = useMemo(() => {
    if (!props.user) return [];

    console.log(props.user);

    console.log("Filtering locations for academy:", props.user.academy);
    console.log(totalLocationData);

    return totalLocationData
      .filter((locationData: any) => locationData.academy?.includes(props.user.academy))
      .filter((each: any) => each.english !== "total");
  }, [props.user, totalLocationData, props.open]);

  const handleSubmit = async () => {
    if (!location) return props.notify?.("error", "지점을 선택해주세요.");
    if (!dateTime) return props.notify?.("error", "날짜/시간을 선택해주세요.");

    const dateObj = new Date(dateTime);

    const dateSqlString = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")} ${String(dateObj.getHours()).padStart(2, "0")}:${String(dateObj.getMinutes()).padStart(2, "0")}:00`;

    console.log("dateSqlString:", dateSqlString);

    // 서버로 보낼 payload 예시
    const payload = {
      userId: props.user?.id,
      location, // english
      dateTime: new Date(dateTime).getTime(), // ms
      direction, // "outside" | "inside"
      dateInserted : dateSqlString
    };

    // TODO: 여기서 postFetch 등으로 저장하면 됨
    console.log("Add Access Payload:", payload);

    const result : any = await postFetch("/dashboard/salary/shopsalary/addaccessrecord", payload);

    if(result.message !== "success"){
        return props.notify?.("error", "출입기록 추가에 실패했어요. 다시 시도해주세요.");
    }

    props.notify?.("success", "출입기록이 성공적으로 추가되었어요.");
    props.handleClose?.();
    props.setAccessUpdate(Math.random())
  };

  return (
    <Modal open={props.open} onClose={props.handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 520,
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 3,
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
          출입기록 수동 추가
        </Typography>

        {/* 지점 선택 */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="location-select-label">지점</InputLabel>
          <Select
            labelId="location-select-label"
            value={location}
            label="지점"
            onChange={(e) => setLocation(e.target.value as string)}
          >
            {locationOptions.map((each: any, index: number) => (
              <MenuItem value={each.english} key={index}>
                {each.korean}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* 날짜/시간 선택 */}
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="날짜/시간"
          type="datetime-local"
          value={dateTime}
          onChange={(e) => setDateTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />

        {/* 입실/퇴실 */}
        <FormControl sx={{ mb: 2 }}>
          <Typography sx={{ mb: 1, fontWeight: 600 }}>구분</Typography>
          <RadioGroup
            row
            value={direction}
            onChange={(e) => setDirection(e.target.value as "outside" | "inside")}
          >
            <FormControlLabel value="outside" control={<Radio />} label="입실" />
            <FormControlLabel value="inside" control={<Radio />} label="퇴실" />
          </RadioGroup>
        </FormControl>

        {/* 버튼 */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button variant="outlined" onClick={props.handleClose}>
            취소
          </Button>
          <Button variant="contained" onClick={handleSubmit}
          disabled={!location || !dateTime || !direction}
          >
            추가
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddAccessModal;